/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type ClientUpdateDto = {
  /**
   * Status to update for the client. Forbidden for role CLIENT.
   */
  status?: ClientUpdateDto.status;
  /**
   * Locale code for the client
   */
  locale: ClientUpdateDto.locale;
  /**
   * Onboarded client name
   */
  name?: string;
  /**
   * Date when 'Privacy policy' and/or 'Terms of use' have been accepted
   */
  legalDocAcceptedAt?: string;
};
export namespace ClientUpdateDto {
  /**
   * Status to update for the client. Forbidden for role CLIENT.
   */
  export enum status {
    PENDING = 'PENDING',
    ACTIVE = 'ACTIVE',
    SUSPENDED = 'SUSPENDED',
    DEACTIVATED = 'DEACTIVATED',
  }
  /**
   * Locale code for the client
   */
  export enum locale {
    EN = 'EN',
    LV = 'LV',
    NO = 'NO',
    FI = 'FI',
  }
}

